// extracted by mini-css-extract-plugin
export var attribution = "_cb-4";
export var authorName = "_cb-5";
export var quote = "_cb-3";
export var testimonial = "_cb-2";
export var trustedBy = "_cb-0";
export var trustedByLabel = "_cb-1";